import { PriceSchemeSelectorBase } from './PriceSchemeSelectorBase';
export default PriceSchemeSelectorBase;
